import { IssueStatus } from "../../../API";

export enum AssessmentFilterStatus {
    PASSED = "PASSED",
    FAILED = "FAILED"
}

export type StatusFilter = IssueStatus | AssessmentFilterStatus;

export const AssessmentFilterStatusText = {
    [AssessmentFilterStatus.PASSED]: "Passed",
    [AssessmentFilterStatus.FAILED]: "Failed"
} as const;


export type IssueFilter = {
    locationIds?: Array<string>;
    issueId?: string;
    date?: {
        start?: Date;
        end?: Date;
    };
    statuses?: Array<StatusFilter>;
    assessmentId?: string;
    tagIds?: Array<string>;
};

export const RESOLVED_ISSUE_STATUS = [IssueStatus.COMPLETED, IssueStatus.ARCHIVED];
export const UNRESOLVED_ISSUE_STATUS = Object.values(IssueStatus).filter(status => !RESOLVED_ISSUE_STATUS.includes(status));
